import React, { useState, useEffect } from 'react';
import { Modal as ModalPopup } from 'react-bootstrap';
import { I18n } from '../../../helpers/i18n';
import client from '../../../helpers/client';
import mvpAuth from '../../../helpers/mvpAuth';
import RatingStarsDisplay from './RatingStarsDisplay';
import starActive from '../../../static/images/mvp/star_active.png';
import './RatingListModal.css';
import './TopicRatingListModal.css';
import moment from 'moment';

function maskReviewerName(name) {
  if (!name || typeof name !== 'string') return '?';
  const s = name.trim();
  if (s.length === 0) return '?';
  if (s.length === 1) return s;
  return s[0] + '***' + s[s.length - 1];
}

function TopicRatingListModal({ visible, topicId, onClose, totalScore, totalCount, initialRatings, isFromTopic = false }) {
  const [ratings, setRatings] = useState([]);
  const [loading, setLoading] = useState(false);

  const hasInitialData = initialRatings != null && Array.isArray(initialRatings);

  useEffect(() => {
    if (!visible) return;
    if (hasInitialData) return;
    if (topicId) {
      setLoading(true);
      client
        .sendRequest({
          path: 'mvp/list-data-evaluate-session-by-topic',
          method: 'GET',
          params: { topicId },
          headers: mvpAuth.getHeaderForMvp(),
        })
        .then(({ data: response }) => {
          setRatings(Array.isArray(response) ? response : []);
        })
        .catch(() => {
          setRatings([]);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setRatings([]);
    }
  }, [visible, topicId, hasInitialData]);

  const displayRatings = hasInitialData ? initialRatings : ratings;
  const displayScore = totalScore ?? 0;
  const displayCount = totalCount ?? 0;

  return (
    <ModalPopup size="lg" show={visible} onHide={onClose} id="rating-list-modal" className="topic-rating-modal" centered style={{ opacity: 1 }}>
      <div className="rating-list-modal-header">
        <span className="rating-list-modal-close" onClick={onClose}>
          ✕
        </span>
        <span className="rating-list-modal-header-title">
          {isFromTopic ? I18n.t('topic_ratings_title') : I18n.t('session_ratings_list_bottom_sheet_title')}
        </span>
      </div>
      <ModalPopup.Body>
        <div className="rating-list-modal-content">
          {displayCount > 0 && (
            <div className="rating-list-summary">
              <img src={starActive} className="rating-list-summary-star-image" alt="" />
              <span className="rating-list-summary-score">{displayScore}</span>
              <span className="rating-list-summary-separator">•</span>
              <span className="rating-list-summary-count">
                {displayCount.toLocaleString()} {I18n.t('ratings_count')}
              </span>
            </div>
          )}

          {loading ? (
            <div className="rating-list-loading">...</div>
          ) : displayRatings.length === 0 ? (
            <div className="rating-list-empty">{I18n.t('no_rating')}</div>
          ) : (
            <div className="rating-list-items">
              {displayRatings.map((item, index) => (
                <div key={index} className="rating-list-item">
                  <div className="rating-list-item-header">
                    <div className="rating-list-item-avatar-wrapper">
                      <div className="rating-list-item-avatar">{(item.name || '?')[0].toUpperCase()}</div>
                      <span className="rating-list-item-role">
                        {item.role || I18n.t('account_type_selection_senior')}
                      </span>
                    </div>
                    <div className="rating-list-item-info">
                      <span className="rating-list-item-name">{maskReviewerName(item.name)}</span>
                      <div className="rating-list-item-meta">
                        <RatingStarsDisplay score={item.score} size={12} />
                        {item.time && (
                          <span className="rating-list-item-date">{moment(item.time).format('DD-MM-YYYY')}</span>
                        )}
                      </div>
                    </div>
                  </div>
                  {item.contentExtra && <p className="rating-list-item-comment">{item.contentExtra}</p>}
                  {item.content && (Array.isArray(item.content) ? item.content : [item.content]).length > 0 && (
                    <div className="rating-list-item-tags">
                      {(Array.isArray(item.content) ? item.content : [item.content]).map((tag, i) => (
                        <span key={i} className="rating-list-item-tag">
                          {tag}
                        </span>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      </ModalPopup.Body>
    </ModalPopup>
  );
}

export default TopicRatingListModal;
